type EventParams = Record<string, string>

type AnalyticsWindow = Window & {
  dataLayer?: unknown[]
  gtag?: (...args: unknown[]) => void
}

/**
 * Sends an anonymous interaction event to Google Analytics / Tag Manager
 * if either is present on the page. Does nothing otherwise.
 * Never pass patient or personal information in params.
 */
export function trackEvent(name: string, params: EventParams): void {
  if (typeof window === 'undefined') return
  const w = window as AnalyticsWindow
  if (typeof w.gtag === 'function') {
    w.gtag('event', name, params)
  } else if (Array.isArray(w.dataLayer)) {
    w.dataLayer.push({ event: name, ...params })
  }
}
